
import { useClientStatuses } from "@/hooks/useClientStatuses";
import { useMemo, useEffect } from "react";

export const useClientStatusOptions = () => {
  const { data: statuses = [], isLoading, error, refetch } = useClientStatuses();

  // Auto-refresh to catch updates
  useEffect(() => {
    const interval = setInterval(() => {
      refetch();
    }, 10000); // Every 10 seconds

    return () => clearInterval(interval);
  }, [refetch]);

  const statusOptions = useMemo(() => {
    console.log("Computing status options from:", statuses);
    
    // التحقق من وجود البيانات
    if (!Array.isArray(statuses) || statuses.length === 0) {
      console.warn("No statuses available, returning default options");
      return {
        all: { label: 'الكل', color: '#6b7280' },
        waiting: { label: 'في الانتظار', color: '#f59e0b' },
        active: { label: 'نشط', color: '#10b981' },
        inactive: { label: 'غير نشط', color: '#6b7280' }
      };
    }

    const options: Record<string, { label: string; color: string }> = {};
    
    // Add "all" option for filters
    options.all = { label: 'الكل', color: '#6b7280' };
    
    try {
      // Add active statuses with safe handling
      statuses
        .filter(status => status && status.is_active && status.status_key && status.name_ar)
        .forEach(status => {
          options[status.status_key] = {
            label: status.name_ar || status.status_key,
            color: status.color || '#6b7280',
          };
        });
    } catch (err) {
      console.error("Error processing statuses:", err);
      // Return safe default if processing fails
      return {
        all: { label: 'الكل', color: '#6b7280' },
        waiting: { label: 'في الانتظار', color: '#f59e0b' }
      };
    }

    console.log("Computed status options:", options);
    return options;
  }, [statuses]);

  const getStatusStyle = (statusKey: string) => {
    try {
      if (!statusKey || !Array.isArray(statuses)) {
        return { backgroundColor: '#6b7280' };
      }
      
      const status = statuses.find(s => s && s.status_key === statusKey);
      if (!status) {
        console.warn("Status not found for key:", statusKey);
        return { backgroundColor: '#6b7280' };
      }
      return { backgroundColor: status.color || '#6b7280' };
    } catch (err) {
      console.error("Error getting status style:", err);
      return { backgroundColor: '#6b7280' };
    }
  };

  const getStatusLabel = (statusKey: string) => {
    try {
      if (!statusKey || !Array.isArray(statuses)) {
        return statusKey || 'غير محدد';
      }
      
      const status = statuses.find(s => s && s.status_key === statusKey);
      const label = status?.name_ar || statusKey || 'غير محدد';
      console.log("Getting label for status key:", statusKey, "->", label);
      return label;
    } catch (err) {
      console.error("Error getting status label:", err);
      return statusKey || 'غير محدد';
    }
  };

  return {
    statusOptions: statusOptions || {},
    getStatusStyle,
    getStatusLabel,
    statuses: statuses || [],
    isLoading: Boolean(isLoading),
    error,
    refetch
  };
};
